import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import styled from 'styled-components';

import { CommonStyles } from '@/atoms/Menu/RadixMenu/common';
const StyledItem = styled(DropdownMenuPrimitive.Item)`
  ${CommonStyles}
`;

export const Item = StyledItem;

export const LinkItem = React.forwardRef<HTMLAnchorElement, LinkItemType>(
  ({ children, ...props }, forwardRef) => {
    return (
      <StyledItem asChild>
        <a
          {...props}
          rel='noreferrer noopenner'
          target='_blank'
          ref={forwardRef}
        >
          {children}
        </a>
      </StyledItem>
    );
  }
);

type LinkItemType = React.ComponentPropsWithRef<'a'> & {
  href: string;
};
